import React from "react";
export const campaignContext = React.createContext();
export const prizeContext = React.createContext();
export const spinContext = React.createContext();